import { useMemo } from 'react';

import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import { parseAsStringEnum, useQueryState } from 'nuqs';

import { useMagicWallCategoriesQuery } from '@query';

import { MagicWallCard, Meta, Sorts } from '@shared/api/types/magicWall';

import { DEFAULT_FILTER, extraFilters, sortTypes } from './constants';

export const useCategoryFilter = () => {
  const query = useMagicWallCategoriesQuery();

  const list = useMemo(() => query.data?.data.flatMap((page) => page ?? []) || [], [query.data]);
  const withAllCategory = [extraFilters, ...list];

  return useQueryState(
    'category',
    parseAsStringEnum<string>(
      withAllCategory.map((category) => category.attributes.name),
    ).withDefault('0'),
  );
};

export const useSortFilter = () => {
  return useQueryState(
    'sort',
    parseAsStringEnum<Sorts>(sortTypes.map((sortType) => sortType.id)).withDefault(DEFAULT_FILTER),
  );
};

export const useTransformData = (
  query: UseInfiniteQueryResult<InfiniteData<any, unknown>, unknown>,
  list: MagicWallCard[],
) =>
  useMemo(() => {
    const data: MagicWallCard[] = [];
    const pages = query.data?.pages[0] as { [key: string]: MagicWallCard };

    if (pages) {
      Object.keys(pages).forEach((key) => {
        if (key !== 'meta') {
          data.push(pages[key] as MagicWallCard);
        }
      });
    }

    return {
      data: data,
      meta: pages?.meta as unknown as Meta,
    };
  }, [list]);
